import parseContentDisposition from 'utils/parseContentDisposition';
import { saveAs } from 'file-saver';

export default (file, extension) => {
  const parsed = parseContentDisposition({ header: file.headers['content-disposition'] });
  saveAs(new Blob([file.data], { type: file.headers['content-type'] }), `${parsed.filename}.${extension}`);
};
